import './landing.css';
import { LandingChart } from './LandingChart';
import type { MouseEventHandler } from 'react';

export default function Landing({
  onEnterApp,
  busy = false,
  message = '',
}: {
  onEnterApp?: MouseEventHandler<HTMLAnchorElement>;
  busy?: boolean;
  message?: string;
}) {
  return (
    <div className="arena-app landing-page">
      <LandingChart />
      <header className="top-bar landing-header">
        <div className="landing-header-actions">
          <a
            className="identity-pill landing-primary landing-login"
            href="/app"
            onClick={onEnterApp}
            aria-disabled={busy}
            aria-busy={busy}
          >
            Login
          </a>
        </div>
      </header>
      <main className="landing-main" aria-label="Run or Die">
        <div className="landing-hero">
          <h1 className="landing-title">runordie</h1>
        </div>
        <a
          className="identity-pill landing-primary landing-start"
          href="/app"
          onClick={onEnterApp}
          aria-disabled={busy}
          aria-busy={busy}
        >
          Start predicting
        </a>
        {message && (
          <p className="landing-auth-status" role="status">
            {message}
          </p>
        )}
      </main>
    </div>
  );
}
